export const modelDataTypeCheckerSymbol = Symbol("modelDataTypeChecker")
export const modelInitializersSymbol = Symbol("modelInitializers")
export const modelUnwrappedClassSymbol = Symbol("modelUnwrappedClass")
